import {
    type FC
} from "react";
import type IMessageTimeProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    renderAccessibleText
} from "../../../../helpers/accessibility";
import {
    formatMessageFullTime,
    formatMessageTime
} from "../../util";
import {
    isolateText
} from "../../../../helpers/locale";
import Tooltip from "../../../tooltip";

const MessageTime: FC<IMessageTimeProps> = ({
    customLocalize,
    customTheme,
    timestamp,
    style
}) => {
    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const fullTime = formatMessageFullTime({
        locale: activeLocale,
        timestamp
    });

    return <Tooltip
        customLocalize={customLocalize}
        customTheme={customTheme}
        title={fullTime}
    >
        {
            renderAccessibleText({
                children: isolateText({
                    text: formatMessageTime({
                        locale: activeLocale,
                        timestamp,
                        localize
                    })
                }),
                variant: "bodySmallSize",
                style: [
                    style,
                    stylesheet.time
                ],
                label: fullTime,
                customTheme,
                color: "low"
            })
        }
    </Tooltip>;
};
export default MessageTime;
